import iconApps from './apps_contrast.png';
import iconArrowDown from './arrow_down.png';
import iconClock from './clock_contrast.png';

export {
  iconApps,
  iconArrowDown,
  iconClock,
};
